import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

import { useCartContext } from './CartProvider';
import CartHeader from './BaseComponents/Cart/layout/CartHeader';
import {
  CartBody,
  CartFooter,
  CartContent,
  CartContainer,
} from './BaseComponents/Cart/layout';
import {
  LocationOrderBody,
  LocationOrderFooter,
  LocationProductBody,
  LocationProductFooter,
} from './BaseComponents/Cart/locationFlow';
import { ProductBody, ProductFooter } from './BaseComponents/Cart/productFlow';
import CheckoutBody from './BaseComponents/Cart/checkoutFlow/CheckoutBody';
import CheckoutFooter from './BaseComponents/Cart/checkoutFlow/CheckoutFooter';
import Basket from './BaseComponents/Cart/Basket/Basket';
import BasketFooter from './BaseComponents/Cart/Basket/BasketFooter';

const Cart = observer(() => {
  const cart = useCartContext();

  const handleClick = useCallback(() => {
    cart.isOpen ? cart.close() : cart.open();
  }, [cart]);

  const location = useLocation();
  const isAccessServicePage = location.pathname.includes(
    '/order-services/access',
  );
  const isMobilityServicePage = location.pathname.includes(
    '/order-services/mobility',
  );
  const isCheckoutPage = location.pathname.includes('/checkout');
  const isAccessProductPage = location.pathname.includes('/access/product');
  const isMobilityProductDetailsPage =
    location.pathname.includes('/product') && !isAccessProductPage;

  console.log(
    isAccessServicePage ||
      cart.isEditingLocations ||
      cart.cartState === 'locations',
    'tung',
  );

  return (
    <CartContainer isOpen={cart.isOpen} onClick={handleClick}>
      <CartHeader
        onIconClick={handleClick}
        isOpen={cart.isOpen}
        totalItems={cart.totalQuantity}
        title={
          (isAccessServicePage && cart.cartState === 'locations') ||
          cart.isEditingLocations ||
          cart.cartState === 'locations'
            ? 'Locations'
            : isCheckoutPage
              ? 'Summary'
              : 'Cart'
        }
      />
      <CartBody isOpen={cart.isOpen}>
        <CartContent
          showScrollbarOnHover={isAccessProductPage && !cart.isEditingLocations}
        >
          {isAccessServicePage && cart.cartState === 'locations' ? (
            <LocationOrderBody />
          ) : isAccessProductPage ? (
            <LocationProductBody />
          ) : isMobilityServicePage ? (
            <ProductBody category="Mobility" />
          ) : isMobilityProductDetailsPage ? (
            <ProductBody category="Mobility" />
          ) : isCheckoutPage ? (
            <CheckoutBody />
          ) : cart.cartState === 'default' ? (
            <Basket />
          ) : (
            <></>
          )}
        </CartContent>
        <CartFooter
          shouldRenderFooter={
            cart.cartState === 'default' ? cart.locations.length > 0 : true
          }
        >
          {isAccessServicePage && cart.cartState === 'locations' ? (
            <LocationOrderFooter />
          ) : isAccessProductPage ? (
            <LocationProductFooter />
          ) : isMobilityServicePage ? (
            <ProductFooter />
          ) : isMobilityProductDetailsPage ? (
            <ProductFooter />
          ) : isCheckoutPage ? (
            <CheckoutFooter />
          ) : cart.cartState === 'default' ? (
            <BasketFooter />
          ) : (
            <></>
          )}
        </CartFooter>
      </CartBody>
    </CartContainer>
  );
});

export default Cart;
